<template>
  <th class="r-table-cell">
    <span v-if="showCell && options.type === 'button'">
      <button
        type="button"
        class="btn btn-link p-0"
        @click="$emit('cellClicked')"
      >{{options.body || body}}</button>
    </span>
    <span v-else-if="showCell && options.type === 'checkbox'">
      <div class="base-control base-checkbox form-group mb-0">
          <input :id="id" :class="`styled-checkbox ${body ? 'checked' : ''}`" type="checkbox" :value="body">
          <label
            style="font-weight: normal;"
            class="mb-0"
            :for="id"
            @click="$emit('cellChecked')"
          ></label>
      </div>
    </span>
    <span
      v-else-if="showCell && options.type === 'string'"
    >{{options.body || body}}</span>
    <span
      v-else-if="showCell && options.type === 'html'"
      v-html="body"
    ></span>
    <span v-else>{{options.placeholder || body}}</span>
  </th>
</template>

<script>
  export default {
    props: {
      id: {
        type: [String, Number],
      },
      body: {
        type: [String, Boolean, Number],
        default: '',
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      showCell() {
        if (this.options.showOnValue === undefined) {
          return true;
        }
        return this.options.showOnValue === this.body;
      }
    }
  };
</script>
